import React, { useEffect, useState } from 'react';
import { Loader2, Users, GraduationCap, ClipboardList, Building2, ShieldCheck } from 'lucide-react';
import api from '../../lib/api';
import { Link } from 'react-router-dom';

const AdminHome = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats').then((r) => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center gap-2 text-mahogany"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>;

  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow mb-2">Admin</div>
        <h1 className="font-serif-display text-4xl text-burgundy">Platform <span className="font-italic-display text-rose-italic">Overview</span></h1>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label="Total Users" value={stats?.users_total ?? 0} />
        <Stat icon={ShieldCheck} label="Active Users" value={stats?.users_active ?? 0} />
        <Stat icon={GraduationCap} label="Approved Facilitators" value={stats?.facilitators_approved ?? 0} />
        <Stat icon={ClipboardList} label="Pending Approvals" value={(stats?.facilitators_pending ?? 0) + (stats?.role_requests_pending ?? 0)} accent />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Stat icon={Building2} label="Ashrams" value={stats?.ashrams_total ?? 0} />
        <Stat icon={Building2} label="Centers" value={stats?.centers_total ?? 0} />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Link to="/dashboard/admin/users" className="p-6 rounded-2xl border border-rose/50 bg-white/70 hover:shadow-lg transition">
          <Users className="w-6 h-6 text-mahogany mb-2" />
          <div className="font-serif-display text-xl text-burgundy">Manage Users</div>
          <div className="text-sm text-mahogany/70">View, filter, and set roles</div>
        </Link>
        <Link to="/dashboard/admin/approvals" className="p-6 rounded-2xl border border-mahogany/30 bg-mahogany/5 hover:shadow-lg transition">
          <ClipboardList className="w-6 h-6 text-mahogany mb-2" />
          <div className="font-serif-display text-xl text-burgundy">Approval Queue</div>
          <div className="text-sm text-mahogany/70">Review facilitator & coordinator submissions</div>
        </Link>
      </div>
    </div>
  );
};

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className={`p-5 rounded-2xl border ${accent ? 'border-mahogany/30 bg-mahogany/5' : 'border-rose/50 bg-white/70'}`}>
    <div className="flex items-center gap-2 text-mahogany/80 text-xs uppercase tracking-widest">
      <Icon className="w-4 h-4" /> {label}
    </div>
    <div className="mt-3 font-serif-display text-3xl text-burgundy">{value}</div>
  </div>
);

export default AdminHome;
